<template>
	<el-footer class="footer clear" height="auto">
		<div class="clear w1200">
			<!--left-->
			<div class="fl">
				<el-menu class="footerMenu" :default-active="$route.path" mode="horizontal" @select="handleSelect">
					<el-menu-item index="/news/news">
						<a href="#/news/news" style="margin-left: -10px;">新闻中心</a>|
					</el-menu-item>
					<el-menu-item index="/job">
						<a href="#/job">人才招聘</a>|</el-menu-item>
					<el-menu-item index="/help">
						<a href="#/help">帮助中心</a>|</el-menu-item>
					<el-menu-item index="">
						<a @click="sendParams">联系我们</a>
					</el-menu-item>
					<el-menu-item index="0">
						<a href="javascript:void(0)"><img src="../assets/img/zs-03.png"></a>
					</el-menu-item>
					<el-menu-item index="1">
						<a href="javascript:void(0)"><img src="../assets/img/zs-04.png"></a>
					</el-menu-item>
					<!--
					<el-menu-item index="2">
						<a href="http://www.cyberpolice.cn/" target="_blank"><img src="../assets/img/zs-05.png"></a>
					</el-menu-item>
					-->
					<el-menu-item index="3">
						<a href="http://www.geotrust.com/ssl/" target="_blank"><img src="../assets/img/zs-06.png"></a>
					</el-menu-item>
				</el-menu>
				<p>Copyright @ 盛迪嘉集团 - 深圳市盛迪嘉支付股份有限公司 ICP：粤B2-20130505 <a href="http://beian.miit.gov.cn/">备案号：粤ICP备13032423号</a></p>
				<p>
					<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030002010443" style="border: 0px; line-height: 20px; display: inline-block; color: #5f5e5e; padding-left: 0px;">
						<img src="../assets/img/ba-icon.png" style="vertical-align: bottom; padding-right: 5px;">粤公网安备 44030002010443号
					</a>
				</p>
			</div>
			<!--right-->
			<div class="fr footer-lx">
				<div class="footer-phone fl">
					<img src="../assets/img/phone-icon.png" />
					<p>4009-303-555<br /><span>周一至周日 9:00-22:00</span></p>
				</div>
				<p class="fl">
					<el-popover popper-class="wxpop" trigger="hover">
						<img src="../assets/img/sdjqbapk.jpg" />
						<img src="../assets/img/sdjzf.jpg" />
						<el-button slot="reference"><img src="../assets/img/wx-gzh.png" />关注微信公众号</el-button>
					</el-popover>
				</p>
			</div>
		</div>
		<!-- <div style=" position: fixed; bottom: 20px; right: 25px;z-index:11;"><a href="javascript:void(0)"><img src="../assets/img/Kf.png" /></a></div> -->
	</el-footer>

</template>

<script>
	export default {
		data() {
			return {
				msg: 'contact'
			}
		},
		methods: {
			sendParams() {
				this.$router.push({
					path: '/about',
					params: {
						dataObj: this.msg
					},
					query: {
						dataObj: this.msg
					}
				})
			}
		}
	}
</script>

<style lang="less">
	#zhichiBtnBox {
		opacity: 0 !important;
		width: 80px !important;
		height: 80px !important;
		cursor: pointer;
	}

	.el-footer {
		padding: 0px !important;
	}

	.footer {
		padding-top: 40px !important;
		padding-bottom: 10px !important;
		background: #eee;
		font-size: 12px;
		color: #5f5e5e;
		line-height: 300%;

		a {
			color: #000;
			padding: 0 10px;
			cursor: pointer;
			display: inline-block;
		}

		.footerMenu {
			background: none;
			border-bottom: none !important;

			.el-menu-item {
				padding: 0px;
				color: #000;
				font-size: 12px;
				text-align: center;
				border-bottom: none;

				img {
					height: 25px;
				}
			}

			.el-menu-item:not(.is-disabled):focus,
			.el-menu-item:not(.is-disabled):hover {
				color: #000;
				background: none;
			}

			.is-active {
				border-bottom: none !important;
			}

			.is-active a,
			li:hover a {
				color: #4d78dd !important;
			}
		}

		.footer-lx {
			margin-top: 20px;
			padding-bottom: 41px;

			>p {
				line-height: 60px;
				color: #000;
				font-size: 18px;

				img {
					vertical-align: middle;
				}

				.el-button {
					background: none;
					border: none;
					padding: 0;
					font-size: 18px;
					color: #000;
				}
			}
		}

		.footerHover {
			color: #5079d9;
		}

		.footer-phone {
			margin-right: 20px;

			img {
				float: left;
			}

			p {
				float: left;
				margin-top: -10px;
				padding-left: 10px;
				color: #000;
				font-size: 20px;
				line-height: 36px;

				span {
					font-size: 14px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/footer.vue